module.exports = __webpack_public_path__ + "img/warning-ico.00538fb9.svg";